module.exports = {"341003100":"甘棠镇","341003101":"仙源镇","341003102":"汤口镇","341003103":"谭家桥镇","341003104":"太平湖镇","341003105":"焦村镇","341003106":"耿城镇","341003107":"三口镇","341003108":"乌石镇","341003200":"新明乡","341003201":"龙门乡","341003203":"新华乡","341003204":"新丰乡","341003205":"永丰乡","341003400":"黄山风景区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341003.json
// module id = 1015
// module chunks = 0